import { render, staticRenderFns } from "./RecordCategoryEditor.vue?vue&type=template&id=be56da18&scoped=true"
import script from "./RecordCategoryEditor.vue?vue&type=script&lang=js"
export * from "./RecordCategoryEditor.vue?vue&type=script&lang=js"
import style0 from "./RecordCategoryEditor.vue?vue&type=style&index=0&id=be56da18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be56da18",
  null
  
)

export default component.exports